<template>
  <div class="form-group col-xs-12 address_container container">
    <label class="control-label control-label-required" for="address">{{ label }}</label>
    <vue-google-autocomplete
      :id="id"
      :address="address"
      v-on:placechanged="getAddressData"
      class="form-control"
      :placeholder="placeholder"
      types="address"
      country="us"
      ref="address"
    ></vue-google-autocomplete>
    <p id="address1_help_block" class="help-block help-block-text"></p>
  </div>
</template>

<script>
import VueGoogleAutocomplete from "vue-google-autocomplete";

export default {
  name: "address-auto-complete",
  components: {
    VueGoogleAutocomplete
  },
  props: {
    label: {
      type: String,
      default: 'Business Address'
    },
    placeholder: {
      type: String,
      default: 'Search for Address'
    },
    id: {
      type: String,
      required: true
    },
    address: {
      type: Object,
      required: false,
      default: {
        address_1: null,
        address_2: null,
        street: null,
        city: null,
        state: null,
        zipcode: null,
        latitude: null,
        longitude: null,
        response: {}
      }
    }
  },
  data() {
    return {
      isLoading: false
    };
  },
  computed: {},
  methods: {
    getAddressData(addressData, placeResultData, id) {
      if (!addressData.street_number) {
        const request = this.$refs.address.autocompleteText;

        axios.post("https://address.acertus.io/api/v1/get-address", {
          'street_1': request.slice(0, request.indexOf(" ")) + ' ' + addressData.route,
          'city': addressData.locality,
          'state': addressData.administrative_area_level_1,
          'zipcode': addressData.postal_code,
        }).then(response => {
          this.address.address_1 = response.data.street_1.substr(0, response.data.street_1.indexOf(" "));
          this.address.city = response.data.city;
          this.address.state = response.data.state;
          this.address.zipcode = response.data.zipcode;
          this.address.latitude = response.data.latitude;
          this.address.longitude = response.data.longitude;
          this.address.response = response.data;
        }).catch(error => {
            // report to bugsnag
        });
      } else {
        this.address.address_1 = addressData.street_number + ' ' + addressData.route;
        this.address.city = addressData.locality;
        this.address.state = addressData.administrative_area_level_1;
        this.address.zipcode = addressData.postal_code;
        this.address.country = addressData.country;
        this.address.latitude = addressData.latitude;
        this.address.longitude = addressData.longitude;
        this.address.response = addressData;
      }
    },
  },
  watch: {
    'address.address_1'(newValue, oldValue) {
      this.$emit('update:address', this.address)
      if (newValue == '') {
        this.$refs.address.autocompleteText = '';
      }
    },
  }
};
</script>